import React, { useCallback, useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import EnterpiseTeam from 'components/EnterpiseTeam';
import BulkAddDataRooms from '../BulkAddDataRooms';
import EnterpriseDataRooms from '../EnterpriseDataRooms';
import { DataRoomSheet } from 'router/subrouters/DataRoom/models/DataRoom';
import BulkUploadDataRooms from '../BulkUploadDataRooms';
import { checkIsNotIgnoreColumn } from '../BulkAddDataRooms/components/utils';
import useRefetch from 'hooks/useRefetch';
import useSocketEvent from 'services/socketService/hooks/useSocketEvent';
import { LISTEN_EVENTS } from 'services/socketService/socketEventNames';
import { DataRoomUploadedEventData } from 'services/socketService/socketEventData';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';

import './RwcAnalyticsLayout.styles.scss';
import './RwcAnalyticsLayout.styles.responsive.scss';

type RwcAnalyticsLayoutProps = {
  className?: string;
};

const RwcAnalyticsLayout: React.FC<RwcAnalyticsLayoutProps> = (props) => {
  const { className } = props;

  const [draftDataRooms, setDraftDataRooms] = useState<DataRoomSheet[]>([]);
  const [columns, setColumns] = useState([]);

  const { enterprise, updateBusinessUnits } = useContext(EnterpriseContext);

  const { refetchFlag, refetch } = useRefetch();

  const classes = classNames('rwc-analytics-layout', className);

  const isBulkUploading = useMemo(
    () => !!draftDataRooms?.length,
    [draftDataRooms?.length],
  );

  const handleOnUpload = useCallback((uploaded: DataRoomSheet[]) => {
    const keys = Object.keys(uploaded[0]).filter(checkIsNotIgnoreColumn);

    setColumns(keys);
    setDraftDataRooms(uploaded);
  }, []);

  const drBulkCreated = useCallback(
    ({ enterpriseId: payloadEnterpriseId }: DataRoomUploadedEventData) => {
      if (enterprise._id !== payloadEnterpriseId) return;

      refetch();
    },
    [enterprise, refetch],
  );

  useSocketEvent(LISTEN_EVENTS.DR_BULK_CREATED, drBulkCreated);

  return (
    <div className={classes}>
      {isBulkUploading && (
        <BulkAddDataRooms
          enterpriseId={enterprise._id}
          draftDataRooms={draftDataRooms}
          columns={columns}
          setDraftDataRooms={setDraftDataRooms}
          setColumns={setColumns}
        />
      )}

      <div
        className={classNames('content-wrapper', {
          hidden: isBulkUploading,
        })}
      >
        <div className="rwc-analytics-layout__cards">
          <EnterpriseDataRooms
            enterprise={enterprise}
            refetchFlag={refetchFlag}
          />
          <BulkUploadDataRooms onUpload={handleOnUpload} />
        </div>
        <EnterpiseTeam
          enterprise={enterprise}
          refetchFlag={refetchFlag}
          withNavigation={false}
          isRWC
          updateBusinessUnits={updateBusinessUnits}
        />
      </div>
    </div>
  );
};

export default RwcAnalyticsLayout;
